import * as React from 'react';
import { isSelectKey } from '../../../common/keyCodes';
import { st, classes } from './Tab.st.css';
import { TABS_DATA_KEYS } from '../dataHooks';
import { Component } from '../GenericComponent';
export const Tab = React.forwardRef((props, ref) => {
    const { index, item, onClick, isActive, isFocusable, indicateActive, className, isTabDiv, } = props;
    let tabType = 'Link';
    if (isTabDiv) {
        tabType = 'Div';
    }
    else if (item.href) {
        tabType = 'Anchor';
    }
    const { title, href, target, rel, prefix, suffix } = item;
    const onSelectTab = (e) => {
        onClick(index, e);
    };
    const onKeyDown = (e) => {
        if (isSelectKey(e)) {
            onSelectTab(e);
            e.preventDefault();
            return false;
        }
        return undefined;
    };
    const dataAttributes = {
        [TABS_DATA_KEYS.tabIndex]: index,
        [TABS_DATA_KEYS.tabIsActive]: isActive,
    };
    const renderTitle = () => {
        const Title = () => (React.createElement("div", { className: classes.tabContentWrapper },
            prefix ? React.createElement("span", { className: classes.prefix }, prefix) : null,
            React.createElement("span", null, title),
            suffix ? React.createElement("span", { className: classes.suffix }, suffix) : null));
        switch (tabType) {
            case 'Anchor':
                return (React.createElement("a", { className: "has-custom-focus", href: href, target: target, rel: rel },
                    React.createElement(Title, null)));
            case 'Link':
                return (React.createElement("span", { role: "link" },
                    React.createElement(Title, null)));
            case 'Div':
            default:
                return React.createElement(Title, null);
        }
    };
    return (React.createElement(Component, { ref: ref, className: st(classes.root, { isActive, indicateActive, hasAnchor: tabType === 'Anchor' }, className, 'has-custom-focus'), ...dataAttributes, "data-hook": props['data-hook'], key: `${title}-${index}`, id: item.id, onClick: onSelectTab, onKeyDown: onKeyDown, tabIndex: tabType === 'Link' || isFocusable ? 0 : -1, ...(tabType !== 'Div' && {
            'aria-current': isActive,
            renderAs: 'li',
        }), ...(tabType === 'Div' && {
            role: 'tab',
            renderAs: 'div',
            'aria-selected': isActive,
            'aria-controls': `${item.id}-tab`,
        }) }, renderTitle()));
});
//# sourceMappingURL=Tab.js.map